import type { BISettings, ToolbarSettings, RichContent } from '@wix/ricos';
import { Version as RceVersion } from '@wix/ricos';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import type { InjectedExperimentsProps } from '@wix/yoshi-flow-editor';
import { withExperiments, useBi } from '@wix/yoshi-flow-editor';
import React from 'react';

import settingsParams from '../settings-params';
import stylesParams from '../styles-params';
import RicosDemo from './ricos-demo';
import { st, classes } from './Widget.st.css';

type WidgetProps = InjectedExperimentsProps & {
  instance: string;
  className?: string;
  appName: string;
  defaultParams: BISettings['defaultParams'];
  mobile: boolean;
  language: string;
  host: any;
  publish: (content: RichContent) => Promise<boolean>;
  content?: RichContent;
  isAdmin: boolean;
  toolbarSettings?: ToolbarSettings;
  isInSEO?: boolean;
};

export default withExperiments<WidgetProps>(
  ({
    experiments,
    className,
    appName,
    defaultParams,
    mobile,
    language,
    host,
    instance,
    publish,
    content,
    isAdmin,
    toolbarSettings,
    isInSEO,
  }) => {
    const settings = useSettings();
    const styles = useStyles();
    const logger = useBi();

    const showDebugHeader = settings.get(settingsParams.showDebugHeader);
    const { currentVersion: rceCurrentVersion } = RceVersion;
    const { style, id: hostId } = host;
    const { siteColors, siteTextPresets, styleParams = { fonts: {}, colors: {} } } = style;
    styleParams.fonts.textFont = styles.get(stylesParams.textFont);
    styleParams.colors.textColor = styles.get(stylesParams.textColor);

    return (
      <div className={hostId}>
        <div className={st(classes.root, {}, className)} data-hook="RICOS-wrapper">
          {showDebugHeader && (
            <div className={classes.header}>
              <h2 data-hook="app-title">{appName}</h2>
              <div className={classes.versions}>
                <div>
                  {mobile ? '' : 'Ricos Version: '}
                  {rceCurrentVersion}
                </div>
              </div>
            </div>
          )}

          <RicosDemo
            defaultParams={defaultParams}
            experiments={experiments}
            locale={language}
            siteColors={siteColors}
            siteTextPresets={siteTextPresets}
            styleParams={styleParams}
            parentClass={hostId}
            instance={instance}
            mobile={mobile}
            publish={publish}
            content={content}
            isAdmin={isAdmin}
            toolbarSettings={toolbarSettings}
            isInSEO={isInSEO}
            logger={logger}
          />
        </div>
      </div>
    );
  }
);
